import { observable, runInAction } from 'mobx';
import { GiftModel, IExchangeRewardsServices, ManageRewardModel, RewardModel, SearchRewardModel } from 'services/Main/exchangeRewards_services';
import { DataResponse } from 'services/response';

export type ExchangeRewardsStore = {
  listGiftRes: DataResponse<GiftModel[]>
  detailRes: DataResponse<GiftModel | undefined>

  // ------------------------------------------------------------------------------------------------
  listManageRes: DataResponse<ManageRewardModel[]>
  // Tra cứu
  searchReward: DataResponse<SearchRewardModel[]>

  // Detail reward
  detailReward: DataResponse<RewardModel | undefined>
};

export interface IExchangeRewardsPresenter {
  createStore(): ExchangeRewardsStore;

  getListGift: (store: ExchangeRewardsStore, data: object) => Promise<void>
  createGift: (store: ExchangeRewardsStore, data: object) => Promise<DataResponse<null>>
  detailGift: (store: ExchangeRewardsStore, id: string) => Promise<void>
  deleteGift: (id: string, typeCode: string) => Promise<DataResponse<null>>


  // =================================================================
  getListManage: (store: ExchangeRewardsStore, data: object) => Promise<void>
  // Tra cứu
  getSearchCustomerExchangeReward: (store: ExchangeRewardsStore, data: object) => Promise<void>
  // chi tiết khách hàng đổi thưởng
  getDetailCustomerExchangeReward: (store: ExchangeRewardsStore, CustomerId: string, ProgramId: string, TypeExchangeReward: string) => Promise<void>
  // cập nhật
  updateExchangeReward(data: object): Promise<DataResponse<null>>

  // export danh sách quản lí đổi thưởng
  exportManageReward(data: object): Promise<void>
  exportSearchReward(data: object): Promise<void>

  syncRewardCode(data: object): Promise<void>
}

export function createExchangeRewardsPresenter({ exchangeRewardsServices }: { exchangeRewardsServices: IExchangeRewardsServices }): IExchangeRewardsPresenter {
  return {
    createStore: (): ExchangeRewardsStore =>
      observable({
        listGiftRes: {
          data: [],
          message: '',
          isSuccess: false,
          paging: {
            totalCount: 0,
            pageIndex: 0,
            pageSize: 0,
            totalPages: 0
          }
        },
        listManageRes: {
          data: [],
          message: '',
          isSuccess: false,
          paging: {
            totalCount: 0,
            pageIndex: 0,
            pageSize: 0,
            totalPages: 0
          }
        },
        detailRes: {
          data: undefined,
          message: '',
          isSuccess: false,
        },
        // Tra cứu
        searchReward: {
          data: [],
          message: '',
          isSuccess: false,
          paging: {
            totalCount: 0,
            pageIndex: 0,
            pageSize: 0,
            totalPages: 0
          }
        },
        // Detail reward
        detailReward: {
          data: undefined,
          message: '',
          isSuccess: false,
        },
      }),

    getListGift: async (store, data) => {
      try {
        const result = await exchangeRewardsServices.getListGifts(data);
        runInAction(() => {
          store.listGiftRes.data = result.data;
          store.listGiftRes.isSuccess = result.isSuccess;
          store.listGiftRes.message = result.message;
          store.listGiftRes.paging = result.paging;
        });
      } catch (error) {
        console.log(error);
      }
    },

    detailGift: async (store, id) => {
      try {
        const result = await exchangeRewardsServices.detailGift(id);
        runInAction(() => {
          store.detailRes.data = result.data;
          store.detailRes.isSuccess = result.isSuccess;
          store.detailRes.message = result.message;
        });
      } catch (error) {
        console.log(error);
      }
    },
    deleteGift: async (id, typeCode) => {
      try {
        const result = await exchangeRewardsServices.deleteGift(id, typeCode);
        return result
      } catch (error) {
        return {
          isSuccess: false,
          message: '',
          data: null
        }
      }
    },
    createGift: async (store, data) => {
      try {
        const result = await exchangeRewardsServices.createGift(data);
        return result
      } catch (error) {
        console.log(error);
        return {
          isSuccess: false,
          message: '',
          data: null
        }
      }
    },

    // =================================================================================================
    getListManage: async (store, data) => {
      try {
        const result = await exchangeRewardsServices.getListManageReward(data);
        runInAction(() => {
          store.listManageRes.data = result.data;
          store.listManageRes.isSuccess = result.isSuccess;
          store.listManageRes.message = result.message;
          store.listManageRes.paging = result.paging;
        });
      } catch (error) {
        console.log(error);
      }
    },

    // Tra cứu
    getSearchCustomerExchangeReward: async (store, data) => {
      try {
        const result = await exchangeRewardsServices.getSearchCustomerExchangeReward(data);
        runInAction(() => {
          store.searchReward.data = result.data;
          store.searchReward.isSuccess = result.isSuccess;
          store.searchReward.message = result.message;
          store.searchReward.paging = result.paging;
        });
      } catch (error) {
        console.log(error);
      }
    },

    // chi tiết khách hàng đổi thưởng
    getDetailCustomerExchangeReward: async (store, CustomerId, ProgramId, TypeExchangeReward) => {
      try {
        const result = await exchangeRewardsServices.getDetailCustomerExchangeReward(CustomerId, ProgramId, TypeExchangeReward);
        runInAction(() => {
          store.detailReward.data = result.data;
          store.detailReward.isSuccess = result.isSuccess;
          store.detailReward.message = result.message;
          store.detailReward.paging = result.paging;
        });
      } catch (error) {
        console.log(error);
      }
    },

    updateExchangeReward: async (data) => {
      try {
        const result = await exchangeRewardsServices.updateExchangeReward(data);
        return result
      } catch (error) {
        console.log(error);
        return {
          data: null,
          isSuccess: false,
          message: ''
        }
      }
    },

    exportManageReward: async (data) => {
      try {
        await exchangeRewardsServices.exportExcelManageReward(data);
      } catch (error) {
        console.log(error);
      }
    },

    exportSearchReward: async (data) => {
      try {
        await exchangeRewardsServices.exportExcelSearchReward(data);
      } catch (error) {
        console.log(error);
      }
    },

    syncRewardCode: async (data) => {
      try {
        return await exchangeRewardsServices.syncRewardCode(data);
      } catch (error) {
        console.log(error);
      }
    },


  }
}
